export class RegisterTrialRequest {
  accountInformation: RegisterRequest;
  companyInformation: BasicCompanyInformation;
}

export class BasicCompanyInformation {
  companyName: string;
  companyDescription: string;
}

export class RegisterRequest {
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  website: string;
}


export class ForgotPasswordRequest {
  email: string;
}

export class ResetPasswordRequest {
  userId: string;
  token: string;
  password: string;
}

export class SetPasswordRequest {
  userId: string;
  token: string;
  password: string;
}
